<!-- 优先使用 iframe 加载 pdfjs viewer -->
<iframe *ngIf="useIframe" #pdfIframe [src]="viewerUrl" width="100%" height="100%" [attr.frameBorder]="0"
    style="border: none;">
</iframe>

<!-- 当 iframe 失败时，使用 object 直接加载 PDF -->
<object *ngIf="!useIframe" [data]="objectUrl" width="100%" height="100%" type="application/pdf">
    <p>您的浏览器不支持显示PDF文件。<a [href]="objectUrl" target="_blank">点击这里下载PDF</a></p>
</object>